import { axios } from '@/utils/request'

export function listOrderNumber (parameter = {}) {
  return axios({
    url: '/payoutBat/listOrderNumber',
    method: 'post',
    data: parameter
  })
}

export function countOrderSelected (parameter = {}) {
  return axios({
    url: '/payoutBat/countOrderSelected',
    method: 'post',
    data: parameter
  })
}

export function listBatch (parameter = {}) {
  return axios({
    url: '/payoutBat/listBatch',
    method: 'post',
    data: parameter
  })
}



export function listPlan (parameter = {}) {
  return axios({
    url: '/payoutBat/listPlan',
    method: 'post',
    data: parameter
  })
}


// 回收
export function createBatch (parameter = {}) {
  return axios({
    url: '/payoutBat/createBatch',
    method: 'post',
    data: parameter,
  })
}

// 再分配
export function updateBatchStatus (parameter = {}) {
  return axios({
    url: '/payoutBat/updateBatchStatus',
    method: 'post',
    data: parameter
  })
}

//坐席操作
export function exportBatchOrders(parameter = {}) {
  return axios({
    url: '/payoutBat/exportBatchOrders',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}

export function importBatchResult(parameter = {}) {
  return axios({
    url: '/payoutBat/importBatchResult',
    method: 'post',
    data: parameter
  })
}

